const STICKY_CLASS = "page-header--is-sticky";

/**
 * Toggles a class while a sticky page header is pinned to the viewport.
 */
export function observeStickyPageHeaders(context) {
  once("titan-rwe-sticky-page-header", "header.page-header", context).forEach(
    (header) => {
      const styles = getComputedStyle(header);

      if (styles.position !== "sticky") {
        return;
      }

      const stickyTop = parseFloat(styles.top) || 0;
      const marker = document.createElement("span");

      marker.setAttribute("aria-hidden", "true");
      marker.style.display = "block";
      marker.style.height = "1px";
      marker.style.marginBottom = "-1px";
      marker.style.pointerEvents = "none";
      header.before(marker);

      let updateScheduled = false;

      const updateStickyState = () => {
        updateScheduled = false;

        const markerTop = marker.getBoundingClientRect().top;
        const isSticky = markerTop < stickyTop && window.scrollY > 0;

        header.classList.toggle(STICKY_CLASS, isSticky);
      };

      const scheduleUpdate = () => {
        if (updateScheduled) {
          return;
        }

        updateScheduled = true;
        requestAnimationFrame(updateStickyState);
      };

      window.addEventListener("scroll", scheduleUpdate, { passive: true });
      window.addEventListener("resize", scheduleUpdate);

      updateStickyState();
    },
  );
}
